import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
const SvgComponent = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        fill="none"
        viewBox="0 0 24 24"
        ref={ref}
        {...props}
    >
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M12 10.925a.7.7 0 0 1 .7.7V15.9a.7.7 0 1 1-1.4 0v-4.275a.7.7 0 0 1 .7-.7"
            clipRule="evenodd"
        />
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M12 4.4a7.6 7.6 0 1 0 0 15.2 7.6 7.6 0 0 0 0-15.2M3 12a9 9 0 1 1 18 0 9 9 0 0 1-18 0"
            clipRule="evenodd"
        />
        <path fill="currentColor" d="M11.203 9.2a.8.8 0 1 1 1.6 0 .8.8 0 0 1-1.6 0" />
    </svg>
);
const ForwardRef = forwardRef(SvgComponent);
export default ForwardRef;
